/**
 * help模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const help = {
    //常见问题与回答
    list (query) {
        return axios.get(base.dev+'/v2/support/list',{params:query});
    },
    // 其他接口…………
}

export default help;
